// BUSINESS DESK — tableau de bord : stats, encaissé du mois, documents récents.
import { useEffect, useState } from "react";
import { deskApi, fmtF, TYPE_LABEL, STATUS_LABEL, getToken } from "./deskApi";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

const ACTIVITY_LABEL = { res: "🏠 Résidences", cer: "🎪 Cérémonie", exp: "🚢 Export attiéké" };

export default function DeskDashboard({ profile, onNew, onOpenDocs }) {
  const [data, setData] = useState(null);
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));

  useEffect(() => {
    deskApi("/dashboard").then(setData).catch(() => {});
  }, []);

  const s = data?.stats;
  return (
    <div data-testid="desk-dashboard">
      <div className="desk-section-title">Bonjour 👋</div>
      <h2 style={{ margin: "2px 0 0", fontSize: 21 }}>{profile?.display_name || "Mon Entreprise"}</h2>

      <div className="desk-stats">
        <div className="desk-stat gold" data-testid="desk-stat-collected">
          <div className="ds-value">{fmtF(s?.collected_month_minor || 0)}</div>
          <div className="ds-label">Encaissé ce mois</div>
        </div>
        <div className="desk-stat" data-testid="desk-stat-invoices">
          <div className="ds-value">{s?.invoices ?? "—"}</div>
          <div className="ds-label">Factures</div>
        </div>
        <div className="desk-stat" data-testid="desk-stat-quotes">
          <div className="ds-value">{s?.quotes ?? "—"}</div>
          <div className="ds-label">Devis</div>
        </div>
        <div className="desk-stat" data-testid="desk-stat-receipts">
          <div className="ds-value">{s?.receipts ?? "—"}</div>
          <div className="ds-label">Reçus de paiement</div>
        </div>
      </div>

      <button className="desk-btn desk-btn-gold" style={{ marginTop: 18 }} data-testid="desk-new-doc-btn" onClick={onNew}>
        ➕ Nouveau document
      </button>

      <div className="desk-section-title">Rapport mensuel (comptable)</div>
      <div className="desk-card" style={{ display: "flex", gap: 10, alignItems: "center" }} data-testid="desk-monthly-report-card">
        <input
          type="month"
          className="desk-input"
          style={{ flex: 1 }}
          data-testid="desk-report-month-input"
          value={month}
          max={new Date().toISOString().slice(0, 7)}
          onChange={(e) => setMonth(e.target.value)}
        />
        <a
          className="desk-btn desk-btn-dark desk-btn-sm"
          style={{ textDecoration: "none", whiteSpace: "nowrap" }}
          data-testid="desk-report-pdf-btn"
          href={`${API_BASE}/api/v3/desk/reports/monthly?month=${month}&t=${getToken()}`}
          target="_blank"
          rel="noreferrer"
        >
          📊 PDF
        </a>
      </div>

      {s && Object.keys(s.by_activity || {}).length > 0 && (
        <>
          <div className="desk-section-title">Facturé par activité</div>
          <div className="desk-card">
            {Object.entries(s.by_activity).map(([aid, total]) => (
              <div key={aid} className="desk-line" style={{ borderBottom: "none", padding: "6px 0" }}>
                <span className="dl-desc">{ACTIVITY_LABEL[aid] || aid}</span>
                <span className="dl-amount">{fmtF(total)}</span>
              </div>
            ))}
          </div>
        </>
      )}

      <div className="desk-section-title">Documents récents</div>
      {(data?.recent || []).length === 0 && <div className="desk-empty">Aucun document — créez votre premier devis ou facture ✨</div>}
      {(data?.recent || []).map((d) => (
        <div key={d.document_id} className="desk-doc-card" data-testid="desk-recent-doc" onClick={onOpenDocs} style={{ cursor: "pointer" }}>
          <div className="desk-doc-head">
            <div>
              <div className="desk-doc-number">{d.document_number || `${TYPE_LABEL[d.document_type]} (brouillon)`}</div>
              <div className="desk-doc-client">{d.customer_snapshot?.name}</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div className="desk-doc-total">{fmtF(d.total_minor)}</div>
              <span className={`desk-badge desk-badge-${d.status === "ISSUED" ? "issued" : d.status === "CANCELLED" ? "cancelled" : "draft"}`}>
                {STATUS_LABEL[d.status]}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
